import * as yup from 'yup';

export const addFeeValidation = yup.object({
  state: yup.string().required(),
  fee: yup.number().required().min(1, 'fee must be greater than 0'),
  serviceFee: yup
    .number()
    .required()
    .min(0, 'ServiceFee must be greater than or equal to 0')
});
